var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { missionTypeEntityName } from '../../../../backend/config/classifiers';
import { missionAccessControlType } from '../../../../backend/extraTypes';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { ClassifierAdminPage, SlideoutFields } from '@juvare/platform-sdk-react/ui/features/classifiers';
import React from 'react';
const EntityDetailsComponent = ({ response }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(SlideoutFields, { fields: [
            { label: t('adminPages.status'), value: t(`adminPages.statusLabels.${response.data.status}`) },
            {
                label: t('adminPages.missionAccessControl'),
                value: t(`adminPages.missionAccessControlLabels.${response.data.missionAccessControl}`),
            },
        ] }));
};
const getFormConfig = (t) => ({
    key: '!form',
    type: 'form',
    children: [
        {
            type: 'form.text',
            key: 'name',
            label: t('adminPages.name'),
            validate: {
                required: true,
            },
        },
        {
            type: 'form.select',
            key: 'status',
            label: t('adminPages.status'),
            validate: {
                required: true,
            },
            values: [
                {
                    value: 'active',
                    label: t('adminPages.statusLabels.active'),
                },
                {
                    value: 'deprecated',
                    label: t('adminPages.statusLabels.deprecated'),
                },
                {
                    value: 'retired',
                    label: t('adminPages.statusLabels.retired'),
                },
            ],
        },
        {
            type: 'form.select',
            key: 'missionAccessControl',
            label: t('adminPages.missionAccessControl'),
            validate: {
                required: true,
            },
            values: [
                { label: t('adminPages.missionAccessControlLabels.manage-missions'), value: 'manage-missions' },
                { label: t('adminPages.missionAccessControlLabels.manage-all-admin-missions'), value: 'manage-all-admin-missions' },
            ],
            tooltip: {
                text: t('adminPages.missionTypeFormTooltip'),
            },
        },
    ],
});
const csvFileHeader = ['ID', 'Name', 'Status', 'Mission Access Control'];
function mapCsvRowToData(row, t) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        const id = ((_a = row.data[0]) !== null && _a !== void 0 ? _a : '').trim();
        const name = ((_b = row.data[1]) !== null && _b !== void 0 ? _b : '').trim();
        const status = ((_c = row.data[2]) !== null && _c !== void 0 ? _c : '').trim().toLowerCase();
        const missionAccessControl = ((_d = row.data[3]) !== null && _d !== void 0 ? _d : '').trim();
        const validStatuses = ['active', 'deprecated', 'retired'];
        if (name.length === 0) {
            row.errors.push(t('adminPages.importErrors.nameRequired'));
        }
        if (status.length === 0) {
            row.errors.push(t('adminPages.importErrors.statusRequired'));
        }
        if (!validStatuses.includes(status)) {
            row.errors.push(t('adminPages.importErrors.invalidStatus', { statuses: validStatuses.join(', ') }));
        }
        if (missionAccessControl.length === 0) {
            row.errors.push(t('adminPages.importErrors.accessControlRequired'));
        }
        // TODO Solve in a better way with CRMS-3067
        const missionAccessControlTypeFromTranslation = missionAccessControlType.find((controlType) => t(`adminPages.missionAccessControlLabels.${controlType}`) === missionAccessControl);
        if (!missionAccessControlTypeFromTranslation) {
            row.errors.push(t('adminPages.importErrors.accessControlInvalid'));
        }
        if (row.errors.length === 0) {
            row.object = {
                id: id,
                data: {
                    name: name,
                    status: status,
                    missionAccessControl: missionAccessControlTypeFromTranslation,
                },
            };
        }
        return Promise.resolve(row);
    });
}
function mapDataToCsvRow(response, t) {
    return __awaiter(this, void 0, void 0, function* () {
        const missionAccessControlLabel = t(`adminPages.missionAccessControlLabels.${response.data.missionAccessControl}`);
        return [response.id, response.data.name, response.data.status, missionAccessControlLabel];
    });
}
export const MissionTypeAdminPage = () => {
    const { t } = useMissionsTranslation();
    return (React.createElement(ClassifierAdminPage, { entity: missionTypeEntityName, title: t('adminPages.missionType'), fullTextSearchField: 'search', getEntityTitle: (row) => row.columns.name, entityDetailsComponent: EntityDetailsComponent, formConfig: getFormConfig(t), csvFileHeader: csvFileHeader, mapCsvRowToData: (row) => mapCsvRowToData(row, t), mapDataToCsvRow: (res) => mapDataToCsvRow(res, t), tableColumns: [
            {
                headerLabel: t('adminPages.name'),
                sortKey: 'name',
                cellFunction: (row) => React.createElement(TextCell, null, row.columns.name),
            },
            {
                headerLabel: t('adminPages.status'),
                sortKey: 'status',
                cellFunction: (row) => React.createElement(TextCell, null, t(`adminPages.statusLabels.${row.columns.status}`)),
            },
            {
                headerLabel: t('adminPages.missionAccessControl'),
                sortKey: 'missionAccessControl',
                cellFunction: (row) => (React.createElement(TextCell, null, t(`adminPages.missionAccessControlLabels.${row.columns.missionAccessControl}`))),
            },
        ] }));
};
